// extracted by mini-css-extract-plugin
export default {"shimmer":"Toggler_shimmer__ViykC","dark_shimmer":"Toggler_dark_shimmer__GyK3M","toggler":"Toggler_toggler__-A4y4"};